<copo-mill-selector [mills]="mills" [validateChange]="createValidateMillsChange()"
	(millsChange)="onMillsChange($event)"></copo-mill-selector>

<div *ngIf="mills">
	<ng-container *ngIf="mills.length > 0 && showBatches; else noResult">
	<!-- Sub header, and quick search -->
	<div class="card-title-block-non-sticky batches-title">
		<div class="card-title-label" translate>ecall-off.choose-batches</div>
		<mat-form-field class="copo-ecall-search-filter quick-search" appearance="outline" subscriptSizing="dynamic">
			<input
				[placeholder]="'ecall.searchfield.extendable' | translate"
				matInput
				type="text"
				spellcheck="false"
				autocomplete="off"
				[formControl]="searchTextControl"/>
			<button type="button" *ngIf="searchTextControl.value" mat-icon-button (click)="searchTextControl.reset('');" tabindex="-1" matSuffix>
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
			<mat-icon svgIcon="search" class="quick-search-icon" *ngIf="!searchTextControl.value" matSuffix></mat-icon>
		</mat-form-field>
	</div>
	<!-- callable order items list -->
	<div class="batches-wrapper card-info-block">
		<!-- results header -->
		<div class="batches-header">
			<copo-datacenter-tool-header
				[currentView]="batchesCurrentView"
				[download]="exportExcelData.bind(this)"
				[nbResults]="gridApi?.getDisplayedRowCount() ?? callableBatches?.length"
				[nbSelectedResults]="selectedRows?.length"
				[views]="batchesViews"
				(customizeView)="onCustomizeView($event)"
				(viewChange)="onViewChange($event)">
			</copo-datacenter-tool-header>
			<div class="selected-only-filter">
				<ng-container *ngIf="batchResults && batchResults.length > 0">
					<copo-slide-button
						class="justify-center"
						labelAfter="filter.all"
						labelBefore="ecall-off.selected-only"
						[checked]="togglePosition"
						(toggleChange)="setTogglePosition($event)">
					</copo-slide-button>
				</ng-container>
			</div>
		</div>
		<!-- results -->
		<ag-grid-angular *ngIf="!noSelectedBatches" class="ag-theme-balham callable-batches-container"
			[gridOptions]="gridCallableBatchesOptions" (gridReady)="onGridReady($event)"
			(rowSelected)="onRowSelected($event)"
			[modules]="agGridModules">
		</ag-grid-angular>
	</div>
	</ng-container>
</div>
<ng-template #noResult>
	<div class="empty-page-text" translate>issue.batch.no.result</div>
</ng-template>